(() => {
  "use strict";
  const RT =
    window.BienestarRuntime ||
    (window.BienestarRuntime = (() => {
      const defs = new Map();
      const roots = (target, selector) => {
        const found = [];
        if (target?.nodeType !== 1 && target !== document) return found;
        if (target !== document && target.matches?.(selector))
          found.push(target);
        target.querySelectorAll?.(selector).forEach((node) => found.push(node));
        return found;
      };
      const mount = (def, root) => {
        if (def.instances.has(root)) return;
        const cleanups = [];
        const onCleanup = (fn) => {
          if (typeof fn === "function") cleanups.push(fn);
        };
        try {
          onCleanup(def.setup(root, onCleanup));
        } catch (error) {
          console.error("[Bienestar]", def.name, error);
        }
        def.instances.set(root, () => {
          for (let i = cleanups.length - 1; i >= 0; i--)
            try {
              cleanups[i]();
            } catch {}
          def.instances.delete(root);
          def.mounted.delete(root);
        });
        def.mounted.add(root);
      };
      const unmount = (def, target) => {
        for (const root of [...def.mounted])
          if (root === target || target.contains?.(root))
            def.instances.get(root)?.();
      };
      const load = (event) =>
        defs.forEach((def) =>
          roots(event.target, def.selector).forEach((root) => mount(def, root)),
        );
      const unload = (event) =>
        defs.forEach((def) => unmount(def, event.target));
      addEventListener("shopify:section:load", load);
      addEventListener("shopify:section:unload", unload);
      return {
        define(name, selector, setup) {
          const previous = defs.get(name);
          if (previous)
            for (const root of [...previous.mounted])
              previous.instances.get(root)?.();
          const def = {
            name,
            selector,
            setup,
            instances: new WeakMap(),
            mounted: new Set(),
          };
          defs.set(name, def);
          roots(document, selector).forEach((root) => mount(def, root));
          return def;
        },
        snapshot() {
          return Object.fromEntries(
            [...defs].map(([name, def]) => [name, def.mounted.size]),
          );
        },
      };
    })());
  RT.define("cuenta", "[data-bienestar-account-root]", (root) => {
    const abort = new AbortController(),
      signal = abort.signal,
      config = window.MantenSafetyConfig || {},
      messages = {
        account:
          "Desde Mi Cuenta puedes encontrar tu suscripción, tus pedidos, tus datos de pago y el acceso a Tu Mejor Etapa™.",
        manage:
          "Pausa, cancela, reactiva o revisa el estado de tus próximas entregas cuando lo necesites.",
        payment:
          "Modifica la tarjeta o el medio de pago asociado a tus renovaciones mensuales.",
        address:
          "Cambia el lugar donde recibirás tus próximos frascos de manera rápida y segura.",
        orders:
          "Consulta tu historial de compras y rastrea el estado de tus envíos activos.",
        program:
          "Entra a tu espacio privado para consultar contenidos exclusivos y registrar tu evolución.",
      };
    const feedback = (control, message) => {
      let status = control.nextElementSibling;
      if (!status?.matches("[data-local-action-status]")) {
        status = document.createElement("span");
        status.className = "local-action-status";
        status.dataset.localActionStatus = "";
        status.setAttribute("role", "status");
        status.setAttribute("aria-live", "polite");
        control.insertAdjacentElement("afterend", status);
      }
      status.textContent = "";
      requestAnimationFrame(() => (status.textContent = message));
    };
    root.querySelectorAll("[data-account-action]").forEach((control) => {
      control.setAttribute("aria-disabled", "true");
      control.addEventListener(
        "click",
        () => {
          if (control.dataset.accountAction === "support") {
            let opened = false;
            try {
              opened =
                config.openInbox?.({
                  intent: "security_pre_purchase",
                  route_type: "subscription",
                  message:
                    "Cuéntanos qué necesitas revisar. Te pediremos solo la información necesaria para encontrar la respuesta aprobada que corresponda a tu situación.",
                }) === true;
            } catch {}
            feedback(
              control,
              opened
                ? "Se abrió el canal seguro de Eusari."
                : "Hablar con soporte",
            );
            return;
          }
          feedback(
            control,
            messages[control.dataset.accountAction] || messages.account,
          );
        },
        { signal },
      );
    });
    root.querySelectorAll("[data-account-route]").forEach((control) =>
      control.addEventListener(
        "click",
        () => {
          const status = root.querySelector(
            "#" + CSS.escape(control.getAttribute("aria-describedby")),
          );
          if (!status) return;
          status.textContent = "";
          requestAnimationFrame(
            () =>
              (status.textContent =
                control.dataset.accountMessage ||
                messages[control.dataset.accountRoute] ||
                ""),
          );
        },
        { signal },
      ),
    );
    return () => abort.abort();
  });
})();
